import { supabase } from "@/integrations/supabase/client";

/**
 * Robust AI response generator with SSE buffering and Vision support
 */
export const generateAiResponse = async ({ 
  prompt, 
  context = "", 
  model = "nova-fast", 
  image = null,
  onChunk
}) => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) throw new Error("Authentication required.");

    const response = await fetch('https://hhvzikakktakbcdbaqxj.supabase.co/functions/v1/chat-ai', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({ prompt, context, model, image, stream: true })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`AI System Error: ${errorText || response.statusText}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let fullContent = "";
    let buffer = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() || "";

      for (const line of lines) {
        const trimmed = line.trim();
        if (!trimmed || !trimmed.startsWith('data: ')) continue;
        
        const dataStr = trimmed.replace('data: ', '').trim();
        if (dataStr === '[DONE]') break;
        
        try {
          const data = JSON.parse(dataStr);
          const content = data.choices[0]?.delta?.content || "";
          if (content) {
            fullContent += content;
            if (onChunk) onChunk(fullContent);
          }
        } catch (e) {}
      }
    }
    
    return fullContent;
  } catch (error) {
    console.error("[AI Service Error]", error);
    throw error;
  }
};